import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import Button from '../../../../../components/button';
import { StepIndicator } from './components/StepIndicator';

type NavigationButtonsProps = {
  onBack: () => void;
  onNext?: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  currentStep: number;
  totalSteps: number;
};

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onNext,
  disableNext = false,
  disableBack = false,
  currentStep,
  totalSteps,
}) => {
  const isLastStep = currentStep === totalSteps - 1;
  const t = useNamespacedTranslation('changeRequests.requestForm');

  const handleNext = () => {
    if (onNext) {
      onNext();
    }
  };

  return (
    <Row className="align-items-center mt-4">
      <Col>
        <Button
          variant="outline-primary"
          label={t('buttons.back')}
          onClick={onBack}
          disabled={disableBack}
        />
      </Col>
      <Col className="text-center">
        <StepIndicator totalSteps={totalSteps} currentStep={currentStep + 1} />
      </Col>
      <Col className="text-end">
        <Button
          type={isLastStep ? 'submit' : 'button'}
          variant="primary"
          label={isLastStep ? t('buttons.confirm') : t('buttons.next')}
          disabled={disableNext}
          onClick={handleNext}
        />
      </Col>
    </Row>
  );
};
